module.exports = __webpack_public_path__ + "static/plan-s6-85dfacbdb3ac51af0c19ede9af4e0b08.png";